import { useState } from "react";

const useTaxesAccountSettings = (findAccountMapping) => {
  const [taxesAccountMapping, setTaxesAccountMapping] = useState({
    vat_payable_account:
      findAccountMapping("vat_payable_account")?.chart_account?.id || "",
    vat_receivable_account:
      findAccountMapping("vat_receivable_account")?.chart_account?.id || "",
  });

  return {
    taxesAccountMapping,
    setTaxesAccountMapping,
  };
};

export default useTaxesAccountSettings;
